import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "fullText", "toggle"]
  static values = {
    desktopLimit: Number,
    mobileLimit: Number,
    readMoreLabel: String,
    readLessLabel: String
  }

  connect() {
    this.expanded = false
    this.handleResize = this.debounce(() => this.render(), 150)
    window.addEventListener("resize", this.handleResize)
    this.render()
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
  }

  toggle() {
    this.expanded = !this.expanded
    this.render()
  }

  render() {
    const full = this.fullTextTarget.textContent.trim()
    const limit = this.currentLimit

    if (!full || full.length <= limit) {
      this.contentTarget.textContent = full
      this.toggleTarget.classList.add("d-none")
      return
    }

    this.toggleTarget.classList.remove("d-none")
    this.toggleTarget.setAttribute("aria-expanded", String(this.expanded))

    if (this.expanded) {
      this.contentTarget.textContent = full + " "
      this.toggleTarget.textContent = this.readLessLabelValue
    } else {
      this.contentTarget.textContent = this.truncateAtWord(full, limit) + "\u2026 "
      this.toggleTarget.textContent = this.readMoreLabelValue
    }
  }

  get currentLimit() {
    return window.matchMedia("(max-width: 767.98px)").matches
      ? this.mobileLimitValue
      : this.desktopLimitValue
  }

  truncateAtWord(text, limit) {
    if (text.length <= limit) return text
    const slice = text.slice(0, limit)
    const lastSpace = slice.lastIndexOf(" ")
    return (lastSpace > 0 ? text.slice(0, lastSpace) : slice).trimEnd()
  }

  debounce(fn, ms) {
    let id
    return (...args) => { clearTimeout(id); id = setTimeout(() => fn(...args), ms) }
  }
}
